var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHourGlass({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 91,
    viewBox: "0 0 89 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 46.5,
    r: 44.5,
    fill: "#F4F7FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.638 47.8245C36.5268 49.3012 33.5935 53.1667 33.5935 57.7053V65.6752H55.1268V57.7053C55.1268 53.1667 52.1935 49.3012 48.0824 47.8245C47.1491 47.4988 46.5268 46.6301 46.5268 45.6529C46.5268 44.6757 47.1491 43.8288 48.0824 43.4813C52.1713 42.0263 55.1046 38.1609 55.1046 33.6222V26.9988H33.5713V33.6439C33.5713 38.1826 36.5046 42.048 40.6157 43.5247C41.5491 43.8505 42.1713 44.7191 42.1713 45.6963C42.1935 46.6301 41.5713 47.4988 40.638 47.8245Z",
    fill: "#C7D9FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0382 43.503C51.7271 42.1783 54.4382 38.9643 54.9937 35.0554H33.6826C34.216 38.9643 36.9493 42.2 40.6382 43.503C40.7937 43.5681 40.9937 43.655 41.216 43.7853C42.3048 44.4151 43.0604 45.5226 43.3048 46.7387L43.4826 47.6073C43.5715 47.9982 43.9271 48.2805 44.3271 48.2805C44.7271 48.2805 45.0826 47.9982 45.1715 47.6073L45.3715 46.6518C45.6159 45.4574 46.3715 44.3933 47.4604 43.7853C47.6826 43.6333 47.9048 43.5464 48.0382 43.503Z",
    fill: "#377FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1046 57.9009H33.5713V65.0455H55.1046V57.9009Z",
    fill: "#377FFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6382 51.9505H44.0605C43.7049 51.9505 43.416 51.6682 43.416 51.3208V50.1915C43.416 49.8441 43.7049 49.5618 44.0605 49.5618H44.6382C44.9938 49.5618 45.2827 49.8441 45.2827 50.1915V51.3208C45.2827 51.6682 44.9938 51.9505 44.6382 51.9505Z",
    fill: "#377FFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6382 54.4479H44.0605C43.7049 54.4479 43.416 54.1656 43.416 53.8182V53.2535C43.416 52.9061 43.7049 52.6238 44.0605 52.6238H44.6382C44.9938 52.6238 45.2827 52.9061 45.2827 53.2535V53.8182C45.2827 54.1873 44.9938 54.4479 44.6382 54.4479Z",
    fill: "#377FFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2823 26H32.4157C31.549 26 30.8379 26.6515 30.8379 27.455C30.8379 28.2585 31.549 28.91 32.4157 28.91H56.2823C57.149 28.91 57.8601 28.2585 57.8601 27.455C57.8379 26.6515 57.149 26 56.2823 26Z",
    fill: "#2437A8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2823 66.9999H32.4157C31.549 66.9999 30.8379 66.3484 30.8379 65.5449C30.8379 64.7415 31.549 64.09 32.4157 64.09H56.2823C57.149 64.09 57.8601 64.7415 57.8601 65.5449C57.8379 66.3484 57.149 66.9999 56.2823 66.9999Z",
    fill: "#2437A8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.55 34.1488C38.6167 34.1488 38.6167 31 36.55 31C34.4833 31 34.4833 34.1488 36.55 34.1488Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.727 36.429C37.8381 36.429 37.8381 34.7351 36.727 34.7351C35.5936 34.7351 35.5936 36.429 36.727 36.429Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3235 1.16968C73.3235 7.74862 68.1074 13.0605 61.647 13.0605C68.1074 13.0605 73.3235 18.3724 73.3235 24.9514C73.3235 18.3724 78.5397 13.0605 85.0001 13.0605C78.5397 13.1092 73.3235 7.74862 73.3235 1.16968Z",
    fill: "#FCB839"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M60.929 0C60.929 2.77778 58.7277 5.01949 56 5.01949C58.7277 5.01949 60.929 7.26121 60.929 10.039C60.929 7.26121 63.1304 5.01949 65.8581 5.01949C63.1304 5.01949 60.929 2.77778 60.929 0Z",
    fill: "#FCB839"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourGlass);
export default __webpack_public_path__ + "static/media/hour-glass.94413141c7e1fd2e79929ae272c722d1.svg";
export { ForwardRef as ReactComponent };